module.exports = __webpack_public_path__ + "static/media/logo.fa903c78.png";